/**
 * `long_text` → **Settings** (spec M1-B5 §6.2, card P-123).
 *
 * Same capture, same answer as `text`: `long_text`'s `Settings` submenu
 * (`editors/long_text/settings-dialog.json`) has no *Customize* row and
 * `longTextSettingsSchema` has one key, `hide_footer` `[09§A.7]`. The character counter and the
 * 2 000-character cap live in the editor, not in settings.
 */
import type { LongTextSettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function LongTextSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<LongTextSettings>) {
  const [draft, patch] = useSettingsDraft<LongTextSettings>(settings);
  return (
    <SettingsForm
      title="Long Text column settings"
      testId="long-text-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <HideSummaryField
        divider={false}
        testId="long-text-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
